import styled from 'styled-components/macro';

export const BackButton = styled.div`
  margin-left: -5px;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  font-weight: bold;
  text-decoration: underline;
  display: flex;
  color: ${({ color }) => color};

  & .icon path {
    text-shadow: 0 4px 6px rgb(0 0 0 / 40%);
  }

  &:hover {
    opacity: 0.85;
  }
  &:active {
    transform: scale(0.98);
  }
`;

export const TaskHeading = styled.h1`
  text-shadow: 0 4px 6px rgb(0 0 0 / 50%);
  @media screen and (max-width: 767px) {
    text-align: center;
    width: 55vw;
    margin: 10px 0 15px 0;
  }
`;

export const Heading = styled.h1`
  text-shadow: 0 4px 6px rgb(0 0 0 / 50%);
  @media screen and (max-width: 767px) {
    margin: 15px 0 10px 0 !important;
  }
`;

export const ScrollBox = styled.div`
  border-radius: 32px;
  flex: 1;
  background: linear-gradient(281.96deg, rgba(225, 225, 234, 0.73) 4.21%, rgba(225, 225, 234, 0.3) 98.56%);
  padding: 12px;

  box-shadow: 0 0 10px 3px rgb(0 0 0 / 16%), inset 0px 0px 12px rgba(255, 255, 255, 0.24);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${({ forMobile }) =>
    forMobile &&
    `
    border-radius: 24px!important;
    `}
`;

export const ButtonContainer = styled.div`
  pointer-events: none;
  position: absolute;
  bottom: 10px;
  z-index: 100;

  ${({ position }) =>
    position == 'left'
      ? `
    left: 0;
    width: 30vw;
    @media screen and (max-width: 1212px) {
    width: 40vw;
  }
  @media screen and (max-width: 842px) {
    width: 45vw;
  }   
  `
      : `right: 0;
    width: 70vw;
    @media screen and (max-width: 1212px) {
    width: 60vw;
  }
  @media screen and (max-width: 842px) {
    width: 55vw;
  }
  
  @media screen and (max-width: 767px) {
    width: 100vw;
  } 

  `}
`;
